import { fetch } from '@/page/index'

/**
 * 解析移动端职责列表（优先 MOBILE / MOBILE_SUPPLIER）。
 *
 * @param {Array} userRespList 用户职责列表
 * @returns {Array} 移动端可用职责
 */
export function resolveMobileRespList(userRespList) {
  const list = userRespList || []
  const mobileList = list.filter(
    (item) => item.systemCode === 'MOBILE' || item.systemCode === 'MOBILE_SUPPLIER'
  )
  return mobileList.length ? mobileList : list
}

/**
 * 从用户职责列表中查找移动端职责项。
 *
 * @param {Object} userInfo 当前登录用户信息
 * @param {number} responsibilityId 职责 ID
 * @returns {Object|null} 职责对象
 */
export function findMobileRespItem(userInfo, responsibilityId) {
  const respList = resolveMobileRespList(userInfo && userInfo.userRespList)
  return respList.find((item) => item.responsibilityId === responsibilityId) || null
}

/**
 * 登录后初始化默认职责，并同步后端 Session 中的 operationRespId。
 * 首页菜单已写死在 Home.vue，此处不再批量拉取/缓存后端菜单。
 *
 * @param {Object} store Vuex store
 * @param {Array} userRespList 用户职责列表
 * @param {string} languageCode 当前语言编码
 * @returns {Promise<{success: boolean, message?: string, responsibilityId?: number}>}
 */
export async function initDefaultResponsibilitySession(store, userRespList, languageCode) {
  const mobileList = resolveMobileRespList(userRespList)
  if (!mobileList.length) {
    return { success: false, message: '暂无移动端职责' }
  }

  const defaultResp = mobileList[0]
  store.commit('SET_RESPONSIBILITY', defaultResp.responsibilityId)

  try {
    const res = await fetch.findBaseMenuByRespId({
      lan: defaultResp.lan || languageCode,
      isValid: true,
      systemCode: defaultResp.systemCode,
      responsibilityId: defaultResp.responsibilityId,
    })
    if (res.status !== 'S') {
      return { success: false, message: res.msg || '同步默认职责失败' }
    }
  } catch (err) {
    return { success: false, message: '同步默认职责失败' }
  }

  return { success: true, responsibilityId: defaultResp.responsibilityId }
}

/**
 * 切换移动端职责并同步后端 Session 中的 operationRespId。
 * 与 PC 端 CHANGE_CURRENT_RESP -> findBaseMenuByRespId 行为保持一致。
 *
 * @param {Object} store Vuex store
 * @param {number} responsibilityId 目标职责 ID
 * @param {string} languageCode 当前语言编码
 * @returns {Promise<{success: boolean, message?: string}>}
 */
export async function syncResponsibilitySession(store, responsibilityId, languageCode) {
  const userInfo = store.state.user.userInfo
  const respItem = findMobileRespItem(userInfo, responsibilityId)
  if (!respItem) {
    return { success: false, message: '未找到对应职责' }
  }

  const res = await fetch.findBaseMenuByRespId({
    lan: respItem.lan || languageCode,
    isValid: true,
    systemCode: respItem.systemCode,
    responsibilityId: respItem.responsibilityId,
  })

  if (res.status !== 'S') {
    return { success: false, message: res.msg || '切换职责失败' }
  }

  store.commit('SET_RESPONSIBILITY', responsibilityId)
  return { success: true }
}



// WEBPACK FOOTER //
// ./src/utils/responsibilityUtils.js